import React, { useMemo } from 'react';

// Category tabs above the Kasse transactions: sum per category for the chosen day / range.
export const KasseCategoryTabs = ({ entries, active, onSelect, catLabel, L }) => {
  const cats = useMemo(() => {
    const m = new Map();
    for (const e of entries) {
      const k = e.item_category || L('Other', 'Sonstiges');
      const c = m.get(k) || { key: k, total: 0, count: 0, cash: 0, card: 0, other: 0 };
      const tot = Number(e.total_price || 0);
      const cash = Number(e.cash_amount || (e.payment_method === 'cash' ? tot : 0));
      const card = Number(e.card_amount || (e.payment_method === 'card' ? tot : 0));
      c.total += tot; c.count += Number(e.quantity || 1); c.cash += cash; c.card += card; c.other += tot - cash - card;
      m.set(k, c);
    }
    return [...m.values()].sort((a, b) => b.total - a.total);
  }, [entries, L]);
  if (!cats.length) return null;
  const sel = cats.find(c => c.key === active);
  const all = cats.reduce((s, c) => ({ total: s.total + c.total, count: s.count + c.count, cash: s.cash + c.cash, card: s.card + c.card, other: s.other + c.other }), { total: 0, count: 0, cash: 0, card: 0, other: 0 });
  const cur = sel || all;
  return (
    <div className="bg-white border border-slate-200/60 rounded-2xl shadow-sm p-4" data-testid="kasse-category-tabs">
      <div className="flex gap-2 overflow-x-auto pb-1">
        {[{ key: null, total: all.total }, ...cats].map(c => (
          <button key={c.key || 'all'} type="button" onClick={() => onSelect(c.key)}
            className={`shrink-0 px-3 py-1.5 rounded-xl text-sm font-semibold border transition-colors ${active === c.key ? 'bg-emerald-600 text-white border-emerald-600' : 'bg-slate-50 text-slate-600 border-slate-200 hover:bg-slate-100'}`}
            data-testid={`kasse-cat-tab-${c.key || 'all'}`}>
            {c.key ? catLabel(c.key) : L('All', 'Alle')}
            <span className={`ml-1.5 text-xs ${active === c.key ? 'text-emerald-100' : 'text-slate-400'}`}>{c.total.toFixed(0)}</span>
          </button>
        ))}
      </div>
      <div className="mt-3 grid grid-cols-2 sm:grid-cols-5 gap-2" data-testid="kasse-cat-summary">
        <div className="col-span-2 sm:col-span-1 bg-emerald-50 rounded-xl p-3">
          <p className="text-[11px] uppercase font-semibold text-emerald-700">{sel ? catLabel(sel.key) : L('All categories', 'Alle Kategorien')}</p>
          <p className="text-xl font-bold text-emerald-900" data-testid="kasse-cat-total">{cur.total.toFixed(2)} CHF</p>
        </div>
        {[[L('Quantity', 'Menge'), cur.count, 'kasse-cat-count'], [L('Cash', 'Bar'), `${cur.cash.toFixed(2)} CHF`, 'kasse-cat-cash'], [L('Card', 'Karte'), `${cur.card.toFixed(2)} CHF`, 'kasse-cat-card'], [L('Other (invoice, online…)', 'Andere (Rechnung, Online…)'), `${cur.other.toFixed(2)} CHF`, 'kasse-cat-other']].map(([l, v, t]) => (
          <div key={t} className="bg-slate-50 rounded-xl p-3">
            <p className="text-[11px] uppercase font-semibold text-slate-500">{l}</p>
            <p className="text-base font-bold text-slate-800" data-testid={t}>{v}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
